import { render } from "./Alpha.vue?vue&type=template&id=42c0c1f5"
import script from "./Alpha.vue?vue&type=script&lang=js"
export * from "./Alpha.vue?vue&type=script&lang=js"
script.render = render

export default script